import script from "./ClassItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassItem.vue?vue&type=script&setup=true&lang=js"

import "./ClassItem.vue?vue&type=style&index=0&id=59c933f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59c933f2"]])

export default __exports__